import type { RawLocation } from 'vue-router';
import type { AssessmentMode } from '../types/assessment-mode.types';

const ASSESSMENT_MODE_ROUTE_NAMES: Record<AssessmentMode, string> = {
  text: 'AssessmentModeText',
  guided: 'AssessmentModeGuided',
  voice: 'AssessmentModeVoice',
};

export const ASSESSMENT_MODE_ROUTE_LOCATIONS: Record<AssessmentMode, RawLocation> = {
  text: {
    name: ASSESSMENT_MODE_ROUTE_NAMES.text,
  },
  guided: {
    name: ASSESSMENT_MODE_ROUTE_NAMES.guided,
  },
  voice: {
    name: ASSESSMENT_MODE_ROUTE_NAMES.voice,
  },
};


